import {
  compressImage,
  convertHeicToJpeg,
  getImageDimensions,
  isHeicLikeFile
} from '../../lomavisCreator/utils/helpers';
import {
  generateFirebaseUploadUrl,
  isMediaImage
} from '../../../redux/slices/lomavisCreator/utils';
import { UPLOAD_TYPE_ATTACHMENT } from '../../../config/constants';
import axios from 'axios';
import axiosClient from '../../../utils/axios';

export async function uploadSingleLogo(params: any): Promise<{
  file: File;
  previewImageUrl: string;
  dimensions?: { width: number; height: number };
  uploadPreset: any;
}> {
  const {
    file: originalFile,
    locationUuid,
    UPLOAD_TYPE_LOGO = UPLOAD_TYPE_ATTACHMENT, // default type, if needed
    t,
    toast
  } = params;

  let file = originalFile;

  // If file is HEIC, convert to JPEG
  if (isHeicLikeFile(file) && convertHeicToJpeg) {
    try {
      file = await convertHeicToJpeg(file);
    } catch (error) {
      console.error('HEIC conversion error:', error);
      // Optionally handle or rethrow error
    }
  }

  // If it's an image, optionally compress it
  if (isMediaImage?.(file) && compressImage) {
    try {
      file = await compressImage(file);
    } catch (error) {
      console.error('Image compression error:', error);
      // Optionally handle or rethrow error
    }
  }

  // Create a local preview URL
  const previewImageUrl = URL.createObjectURL(file);

  // Get dimensions (if needed)
  let dimensions: { width: number; height: number } | undefined;

  try {
    dimensions = await getImageDimensions(previewImageUrl);
  } catch (error) {
    console.error('Error getting image dimensions:', error);
  }

  // const recaptchaToken = await executeRecaptcha('uploadAssets');

  let uploadPreset = null;
  try {
    uploadPreset = await generateFirebaseUploadUrl(
      {
        // recaptcha: recaptchaToken,
        content_type: file.type,
        filesize_in_bytes: file.size,
        filename: file.name,
        location_uuid: locationUuid,
        width: dimensions?.width,
        height: dimensions?.height,
        upload_type: UPLOAD_TYPE_ATTACHMENT // e.g. 'LOGO_UPLOAD'
      },
      {},
      () => {
        console.error('Error generating upload presets');
        toast?.error?.(
          t?.('errors.unableToGeneratePresets') || 'Unable to generate presets',
          { duration: 4000, position: 'top-right' }
        );
      },
      () => {
        console.log('Preset generation success');
      }
    );
  } catch (error) {
    console.error('Error generating Firebase upload URL:', error);
  }

  // Return final metadata object for this logo file
  return {
    file,
    previewImageUrl,
    dimensions,
    uploadPreset
  };
}

export const putWithFile = async (
  file: File | Blob,
  uploadPreset: {
    url: string;
    confirm_url: string;
    headers?: Record<string, string>;
  },
  successCallback: () => void,
  errorCallback: () => void
): Promise<any> => {
  try {
    // Destructure what you need from uploadPreset
    const { url, confirm_url, headers = {} } = uploadPreset;

    // Merge optional headers with the required Content-Type
    const config = {
      headers: {
        ...headers,
        'Content-Type': file.type,
      },
    };

    // 1) Upload the file with axios PUT
    const response = await axios.put(url, file, config);

    // 2) Confirm the upload
    try {
      const confirmResponse = await axiosClient.put(confirm_url, {
        success: true,
      });
      console.log('Upload confirmation:', confirmResponse.data);
      successCallback();
    } catch (err) {
      console.error('Error in confirm request:', err);
      // You might choose to call errorCallback here as well
    }

    // Return the response from the PUT (or from confirm, if you prefer)
    return response;
  } catch (err) {
    console.error('Error uploading file:', err);
    errorCallback();
    throw err;
  }
};
